export enum ROLE_ALL {
  Superadmin = "superadmin", // 超级管理员
  Teacher = "headquarters_teacher", // 总部老师
  AdminTeacher = "headquarters_teacher_admin" // 总部老师管理
}
export const ROLE_COURSE: string[] = [
  "superadmin",
  "headquarters_teacher",
  "headquarters_teacher_admin"
];

export const ROLE_BASIC: string[] = ["superadmin"];

export default {
  ROLE_BASIC,
  ROLE_COURSE
};
